export const MODAL_CONSTANTS  = {
  PRIZES: 'PRIZES',
  INFORMATION: 'RULES',
  USER_PROFILE: 'USER_PROFILE',
  SIGN_IN_POPUP: 'SIGN_IN_POPUP',
  VERIFY_POPUP: 'VERIFY_POPUP',
  WIN_POPUP: 'WIN_POPUP',
  CALENDAR_POPUP: 'CALENDAR_POPUP',
};
